import React from "react";

import get from "lodash/get";
import { FieldProps, useRecordContext } from "react-admin";
import { Chip } from "@mui/material";

import "./ResourceTypesField.css";

// Make source a required prop
export type Props = FieldProps & { source: string };

const ResourceTypesField = ({ source }: Props) => {
  const record = useRecordContext();
  const value = get(record, source);

  return (
    <div className="App-ResourceTypesField">
      {value?.mail && <Chip label="Mail" />}
      {value?.traffic && <Chip label="Traffic" />}
      {value?.vhost && <Chip label="VHost" />}
      {value?.vm && <Chip label="VM" />}
      {value?.domain && <Chip label="Domains" />}
    </div>
  );
};

export default ResourceTypesField;
